import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import {
    OAUTH_CONNECTION_REQUEST_SOURCE,
    networkCompaniesFromCanonical,
} from '../consts'

const AuthButton = ({ item, onClick }) => {
    const network = networkCompaniesFromCanonical(item.type)
    return (
        <Button
            variant="outlined"
            color="neutral"
            onClick={() =>
                onClick({
                    source: OAUTH_CONNECTION_REQUEST_SOURCE.SETTINGS,
                    account_type: item.account_type,
                })
            }
            startDecorator={network.icon}
        >
            Connect {network.displayName}
        </Button>
    )
}

export const SocialAuthButtons = ({ networks, connectAccount }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            {networks.map((item) => (
                <AuthButton
                    key={item.type}
                    item={item}
                    onClick={connectAccount}
                />
            ))}
        </Box>
    )
}
